import { BaseModel } from '../base.model'
import * as moment from 'moment'
const oneDay = 24 * 60 * 60

export class OnlineInterviewerSheduleShift extends BaseModel<OnlineInterviewerSheduleShift> {
  static DEFAULT_ATTRIBUTES = {
    capacity: 1,
    centerIds: [], 
    programIds: [],
    types: [],
    state: 'active'
  }
  
  periodId: number
  from: number
  to: number
  capacity: number
  centerIds: number[] 
  programIds: number[]
  types: string[]
  state: string
  
  dayIndex?: number
  timeFrom?: string
  timeTo?: string

  /**
   * Создает окно записи для дня в периоде
   * @param dayIndex Индекс дня в периоде
   * @returns Новый экземпляр для окна записи
   */
  static create(dayIndex: number): OnlineInterviewerSheduleShift {
    let offset = dayIndex * oneDay
    return new OnlineInterviewerSheduleShift({
      from: offset,
      to: offset,
      state: "active"
    })
  }

  constructor(attributes: Object) {
    super(attributes)
    
    this.dayIndex = Math.floor(this.from / oneDay)
    this.timeFrom = this.from ? moment.unix(this.from).utc().format("HH:mm") : ""
    this.timeTo = this.to ? moment.unix(this.to).utc().format("HH:mm") : ""
  }

  /**
   * Копирует параметры из исходного окна записи
   * Начало, конец, количество мест, центры, программы и типы
   * @param shift Исходное окно записи
   * @returns Заполненный скопированными данными экземпляр окна записи
   */
  copyFrom(shift: OnlineInterviewerSheduleShift): OnlineInterviewerSheduleShift {
    this.timeFrom = shift.timeFrom
    this.timeTo = shift.timeTo
    this.capacity = shift.capacity
    this.centerIds = shift.centerIds.slice()
    this.programIds = shift.programIds.slice()
    this.types = shift.types.slice()
    return this
  }

  remove(): void {
    this.state = 'removed'
  }

  close(): void {
    this.state = 'closed'
  }

  get isRemoved(): boolean {
    return this.state == 'removed'
  }

  get isDisabled(): boolean {
    return this.state == 'disabled'
  }

  get isActive(): boolean {
    return this.state == 'active'
  }

  get isClosed(): boolean { 
    return this.state == 'closed'
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/online-interviewer-schedule/online-interviewer-schedule-shift.model.ts